export { default as Svg } from './Svg';
